<template>
  <v-dialog
    v-model="alwaysOpen"
    :fullscreen="isMobile"
    width="80%"
    max-width="700px"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card class="form-dialog form-dialog--new-user">
      <v-icon
        class="form-dialog__button form-dialog__button--close"
        @click="close"
      >
        mdi-close
      </v-icon>

      <h1 class="form-dialog__title">{{ title }}</h1>
      <span class="form-dialog__subtitle">
        This discount list is managed by ParkMan and cannot be edited. The dates listed below belong to this list
      </span>
      <data-table-country-holidays
        :data="items"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import DataTableCountryHolidays from '../DataTable/DataTableCountryHolidays.vue'

export default {
  name: 'FormCountryHolidaysPopup',
  props: {
    holidays: {
      type: Array,
      default: () => []
    },
    discount: {
      type: Object,
      default: null
    }
  },
  components: {
    DataTableCountryHolidays
  },
  data() {
    return {
      alwaysOpen: true,
      mobileBreakpoint: 767
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    },
    title() {
      return this.discount?.discount_list_name || 'Holiday dates'
    },
    items() {
      return (this.holidays || []).map((h) => ({
        holiday_date: h.holiday_date,
        discount_percentage: this.discount?.discount_percentage,
        product_name: this.discount?.product_name
      }))
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
@import '@/style/common';

.v-text-field__details {
  padding: 0px !important;
}
</style>
